export default {
    token: '',
    permissions: []
}